<template lang="pug">
  .b2b-page-sendcover
    ods-module
      ods-form(
        ref='formSendCoverInvoice',
        :model='formSendCoverInvoiceForm',
        :rules='rulesSendCoverInvoiceForm',
        label-width='14rem',
        label-position='top',
        size='mini')
        ods-row(type='flex')
          ods-col(:span='24')
            ods-form-item(
              :label='$t("pendingtask.createcover.cover.title")',
              size='mini')
              ods-radio(
                v-model='radio',
                :disabled="(this.radio && this.radio=='2')"
                label='1')
                | {{ $t('pendingtask.createcover.rbInvoice') }}
              ods-radio.separate(
                v-model='radio',
                :disabled="(this.radio && this.radio=='1')"
                label='2')
                | {{ $t('pendingtask.createcover.rbPaymentProposal') }}

        ods-row(type='flex')
          ods-col(:span='12')
            ods-form-item(
              :label='$t("pendingtask.createcover.cover.user.title")',
              size='mini',
              prop='username')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='formSendCoverInvoiceForm.username',
                filterable,
                :placeholder='$t("pendingtask.createcover.cover.user.placeholder")',
                @change='selectedUser')
                ods-option(
                  v-for='option in usuarios',
                  :key='option.id',
                  :label='option.username + "-" + option.name + (option.firstSurname ? " " + option.firstSurname : "") + (option.secondSurname ? " " + option.secondSurname : "")',
                  :value='option.username')
          ods-col(:span='2')
          ods-col(:span='10')
            ods-form-item(
              size='mini')
              ods-checkbox.middle(
                @change='updateUsers()'
                :label='$t("msg_generics.all_centres")',
                v-model='formSendCoverInvoiceForm.allProjects')

        ods-row(type='flex')
          ods-col(:span='24')
            ods-form-item(
            :label='formSendCoverInvoiceForm.name',
            size='mini',
            prop='name')

    ods-row.form-actions()
      ods-col(:span='24')
        ods-button(
          :disabled="(!this.radio)"
          type='primary',
          @click='sendSignatureInvoice("formSendCoverInvoice")')
          | {{ $t('pendingtask.createcover.cover.signature.btnSignature') }}
        ods-button(
          :disabled="(!this.radio)"
          type='primary',
          @click='sendAprrovalInvoice("formSendCoverInvoice")')
          | {{ $t('pendingtask.createcover.cover.aprroval.btnAprroval') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-sendcover',
  mixins: [Utils],
  data () {
    return {
      projectId: null,
      buyerId: null,
      centreCode: null,
      radio: null,
      searchType: 'RECEIVED',
      usuarios: [], // combo usuarios
      auxListUsers: [],
      formSendCoverInvoiceForm: {
        username: null,
        name: null
      },
      rulesSendCoverInvoiceForm: {
        username: [
          {
            required: true,
            message: this.$t(
              'pendingtask.createcover.cover.user.user_required'
            ),
            trigger: 'change'
          }
        ]
      }
    }
  },

  computed: {
    ...mapGetters([
      'invoiceNoteIdsPendingTask',
      'projectNamependingTask',
      'radioOption'])
  },

  methods: {
    ...mapActions([
      'sendSignature',
      'sendAprroval',
      'getUsersPendingTask',
      'getInvoiceNote',
      'usersPendingTaskState',
      'radioOptionState',
      'getProjectByName'
    ]),

    // Usuario seleccionado
    selectedUser (data) {
      const user = this.usuarios.find(function (t) {
        return t.username === data
      })
      this.formSendCoverInvoiceForm.name = user.name + '   ' + user.firstSurname
    },

    // Enviar factura/s a firma
    sendSignatureInvoice (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('pendingtask.createcover.cover.signature.notify')
          })

          try {
            const params = {
              username: this.formSendCoverInvoiceForm.username,
              // projectId:localproject
              invoiceAttachmentCategoryId: this.radio,
              invoiceNoteId: this.invoiceNoteIdsPendingTask
            }
            await this.sendSignature(params)
            this.$notify({
              title: this.$t('pendingtask.createcover.cover.send_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })

            // Redirigimos a listado
            router.push({ name: 'tareaspendientes-table' })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            this.$refs[formName].resetFields()
            load.close()
          }
        } else {
          console.log('error submit!!!!')
        }
      })
    },

    // Enviar factura/s a visto bueno
    sendAprrovalInvoice (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('pendingtask.createcover.cover.aprroval.notify')
          })

          try {
            const params = {
              username: this.formSendCoverInvoiceForm.username,
              // projectId:localproject
              invoiceAttachmentCategoryId: this.radio,
              invoiceNoteId: this.invoiceNoteIdsPendingTask
            }
            await this.sendAprroval(params)

            this.$notify({
              title: this.$t('pendingtask.createcover.cover.send_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })

            // Redirigimos a listado
            router.push({ name: 'tareaspendientes-table' })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            this.$refs[formName].resetFields()
            load.close()
          }
        } else {
          console.log('error submit!!!!')
        }
      })
    },
    async updateUsers () {
      this.usuarios = []
      this.formSendCoverInvoiceForm.username = null
      if (this.formSendCoverInvoiceForm.allProjects) {
        this.centreCode = null
        this.buyerId = null
      } else {
        await this.getProject()
      }
      await this.getUserByUsername()
    },

    async getUserByUsername (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas

        const request = {
          projectId: this.projectId,
          partyId: this.buyerId,
          centreCode: this.centreCode,
          size: 1000000,
          username: data
        }
        console.log('Obtenemos los usuarios del servicio: ', this.projectId)
        const response = await this.getUsersPendingTask(request)
        this.auxListUsers = response.data.content
        this.usuarios = this.auxListUsers
      } catch (error) {
        console.log('getUserByUsername CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async getProjectByNameOnDatabase (invoice) {
      let project = null
      try {
        const proj = await this.getProjectByName(
          invoice.projectName
        )
        if (proj.length > 1) {
          project = proj[0]
        } else {
          project = proj
        }
        console.log('>> project', project)
        this.projectId = project.id
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async getProject () {
      if (this.invoiceNoteIdsPendingTask.length > 1) {
        this.buyerId = null
        this.centreCode = null
        let project = null
        const proj = await this.getProjectByName(this.projectNamependingTask)
        if (proj.length > 1) {
          project = proj[0]
        } else {
          project = proj
        }
        this.projectId = project.id
      } else {
        const params = {
          invoiceNoteId: this.invoiceNoteIdsPendingTask,
          searchType: this.searchType
        }
        const factura = await this.getInvoiceNote(params)
        this.buyerId = factura.buyerId
        this.centreCode = factura.centreBuyerCodes
        if (factura.idProject) {
          this.projectId = factura.idProject
        } else {
          await this.getProjectByNameOnDatabase(factura)
        }
      }
    },

    async getNotificationErrorMessage (error) {
      console.log(error)
      let errorSms = ''
      const statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error, 10000)
    }
  },

  async created () {
    this.radio = this.radioOption
    console.log('radioOptionState2: ', this.radioOption)
    console.log('this.$route.params: ', this.$route.params)
    await this.getProject()
    console.log('Nombre del servicio: ', this.projectNamependingTask)
    console.log('id del servicio antes: ', this.projectId)
    if (!this.projectId) {
      this.projectId = this.$route.params.projectId
    }
    if (!this.buyerId && !this.invoiceNoteIdsPendingTask && this.$route.params.invoiceId) {
      const invoiceId = this.$route.params.invoiceId
      const params = {
        invoiceNoteId: invoiceId,
        searchType: this.searchType
      }
      const factura = await this.getInvoiceNote(params)
      this.buyerId = factura.buyerId
      this.centreCode = factura.centreBuyerCodes
    }
    await this.getUserByUsername()
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-sendcover {
  padding: 40px 40px 40px 40px;
  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
      margin-left: 20px;
    }
  }

  .collapse{
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button{
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }

  ::v-deep .separate {
    margin-left: 10%;
  }
  label.ods-checkbox.middle {
    margin-top: 26px;
  }
}
</style>
